<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M14.0019 0L12.0292 1.74842L14.3209 3.77797H13.7987C6.18983 3.77797 0 9.26276 0 16.0026V20H3.1972V16.0026C3.1972 10.8247 7.95222 6.61073 13.7973 6.61073H14.5927L12.0292 8.88124L14.0019 10.6282L20 5.31411L14.0019 0Z"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'SkipSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
